module.exports = __webpack_public_path__ + "static/media/twitter.c4f438fa.svg";